import { TipoZona, Udm, Moneda } from "../../../isp.žapi.zonas/constantesApiZonas";

const tiposZona = [
    // { label: "Plan de Internet", value: TipoZona.PlanInternet },
    { label: "Servicios Gener.", value: TipoZona.ServiciosGen },
    { label: "Articulo", value: TipoZona.Articulo },
];

const udms = [
    // { label: "Mensual", value: Udm.Mensual },
    { label: "Unidad", value: Udm.Unidad },
];

const monedas = [
    { label: "Soles (S/)", value: Moneda.Soles },
    { label: "Dólares ($)", value: Moneda.Dolares },
];

export { tiposZona, udms, monedas };
